import { render, staticRenderFns } from "./AddComponToKu.vue?vue&type=template&id=c9f7a754&scoped=true&"
import script from "./AddComponToKu.vue?vue&type=script&lang=js&"
export * from "./AddComponToKu.vue?vue&type=script&lang=js&"
import style0 from "./AddComponToKu.vue?vue&type=style&index=0&id=c9f7a754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f7a754",
  null
  
)

export default component.exports